import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  date_from: null,
  date_to: null,
  time: 'subMonth', // fallback for backward compatibility
  dateRange: null, // moment range for UI
};

const dashboardFilterSlice = createSlice({
  name: 'dashboardFilter',
  initialState,
  reducers: {
    setDateRange(state, action) {
      const { payload } = action;
      if (payload) {
        state.dateRange = payload;
        state.date_from = payload[0]?.format('YYYY-MM-DD') || null;
        state.date_to = payload[1]?.format('YYYY-MM-DD') || null;
        // Clear time when date range is set
        state.time = null;
      } else {
        // Reset to default
        state.dateRange = null;
        state.date_from = null;
        state.date_to = null;
        state.time = 'subMonth';
      }
    },
    setTimeFilter(state, action) {
      const { payload } = action;
      state.time = payload;
      // Clear date range when time filter is used
      state.dateRange = null;
      state.date_from = null;
      state.date_to = null;
    },
    resetFilter(state) {
      state.dateRange = null;
      state.date_from = null;
      state.date_to = null;
      state.time = 'subMonth';
    },
  },
});

export const { setDateRange, setTimeFilter, resetFilter } =
  dashboardFilterSlice.actions;

// Selector to get API params with proper priority
export const selectDashboardParams = (state) => {
  const { date_from, date_to, time } = state.dashboardFilter;
  // If date_from is provided, use date range and ignore time
  if (date_from) {
    return {
      date_from,
      date_to: date_to || moment().format('YYYY-MM-DD'),
    };
  }
  // Otherwise use time parameter
  return { time: time || 'subMonth' };
};

export default dashboardFilterSlice.reducer;
